import { Injectable } from '@angular/core';
import { User } from '../models/user.model';

const KEYS = {
  TOKEN: 'token',
  CURRENT_USER: 'current_user',
  COMPANY_ID: 'company_id',
  RECOVERY_EMAIL: 'recoveryEmail',
  FILTERED_COMPANIES: 'filtered_companies',
  BEEP_VOLUME: 'orders_beep_volume',
  UI_LANGUAGE: 'uiLanguage'
} as const;

@Injectable({ providedIn: 'root' })
export class StorageService {
  getToken(): string | null {
    return localStorage.getItem(KEYS.TOKEN);
  }

  setToken(token: string): void {
    localStorage.setItem(KEYS.TOKEN, token);
  }

  getCurrentUser(): User | null {
    const raw = localStorage.getItem(KEYS.CURRENT_USER);
    return raw ? (JSON.parse(raw) as User) : null;
  }

  setCurrentUser(user: User): void {
    localStorage.setItem(KEYS.CURRENT_USER, JSON.stringify(user));
  }

  getCompanyId(): number | null {
    const raw = localStorage.getItem(KEYS.COMPANY_ID);
    if (raw === null) return null;
    const n = Number(raw);
    return isNaN(n) ? null : n;
  }

  setCompanyId(id: number): void {
    localStorage.setItem(KEYS.COMPANY_ID, String(id));
  }

  getRecoveryEmail(): string | null {
    return localStorage.getItem(KEYS.RECOVERY_EMAIL);
  }

  setRecoveryEmail(email: string): void {
    localStorage.setItem(KEYS.RECOVERY_EMAIL, email);
  }

  removeRecoveryEmail(): void {
    localStorage.removeItem(KEYS.RECOVERY_EMAIL);
  }

  getFilteredCompanies(): boolean {
    return JSON.parse(localStorage.getItem(KEYS.FILTERED_COMPANIES) ?? 'false');
  }

  setFilteredCompanies(value: boolean): void {
    localStorage.setItem(KEYS.FILTERED_COMPANIES, String(value));
  }

  getBeepVolume(): number {
    const raw = localStorage.getItem(KEYS.BEEP_VOLUME);
    return raw !== null ? Number(raw) : 1;
  }

  setBeepVolume(volume: number): void {
    localStorage.setItem(KEYS.BEEP_VOLUME, String(volume));
  }

  getUiLanguage(): string | null {
    return localStorage.getItem(KEYS.UI_LANGUAGE);
  }

  setUiLanguage(lang: string): void {
    localStorage.setItem(KEYS.UI_LANGUAGE, lang);
  }

  clear(): void {
    localStorage.clear();
  }
}
